var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imageUrl)?_c('cropper',{ref:"cropper",staticClass:"cropper",attrs:{"src":_vm.imageUrl,"stencil-size":{
    width: _vm.minImageWidth * _vm.scaleToPreview,
    height: _vm.minImageHeight * _vm.scaleToPreview
  },"stencil-props":{
    handlers: {},
    movable: false,
    resizable: false,
    aspectRatio: _vm.minImageWidth / _vm.minImageHeight
  },"min-width":_vm.minImageWidth,"min-height":_vm.minImageHeight,"image-restriction":"stencil"},on:{"ready":_vm.onCropperReady}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }